module.exports = __webpack_public_path__ + "ab328552d624ddd94ea7ef7576b3d7c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_3.png
// module id = 1797
// module chunks = 1